const HASH_PARAMETER_NAME = 'f';

function getRawHashParameter(hash, parameterName) {
    if (!hash || typeof hash !== 'string' || !/^#/.test(hash)) {
        return null;
    }

    const parameterPrefix = `${parameterName}=`;
    const parameter = hash.slice(1).split('&').find(value => value.indexOf(parameterPrefix) === 0);

    return parameter ? parameter.slice(parameterPrefix.length) : null;
}

export function containsFacetState(hash){
    const facetState = getRawHashParameter(hash, HASH_PARAMETER_NAME);

    return typeof facetState === 'string' && facetState.length > 0;
}

export function getStateFromHash(hash) {
    if (!containsFacetState(hash)) {
        return null;
    }

    return getRawHashParameter(hash, HASH_PARAMETER_NAME);
}

export function buildHashStateString(value) {
    return typeof value === 'string' && value.length > 0 ? `#${HASH_PARAMETER_NAME}=${value}` : '';
}
